import * as React from "react";

function Rupiah(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 12c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11 11-4.925 11-11zM3 12a9 9 0 1118 0 9 9 0 01-18 0z"
      />
      <path d="M10.529 14l-1.08-1.56H8.257V14H6.96V8.4h2.424c.496 0 .925.083 1.288.248.368.165.65.4.848.704.197.304.296.664.296 1.08 0 .416-.101.776-.304 1.08-.197.299-.48.528-.848.688L11.92 14h-1.392zm-.024-3.568c0-.315-.102-.555-.304-.72-.203-.17-.499-.256-.888-.256H8.257v1.952h1.056c.39 0 .685-.085.888-.256.202-.17.304-.41.304-.72zm4.795-.8c.4 0 .762.093 1.088.28.33.181.589.44.776.776.186.33.28.717.28 1.16 0 .443-.094.832-.28 1.168a2.01 2.01 0 01-.776.776 2.197 2.197 0 01-1.088.272c-.55 0-.982-.173-1.296-.52v2.008h-1.248V9.696h1.192v.496c.309-.373.76-.56 1.352-.56zm-.216 3.408c.32 0 .581-.107.784-.32.208-.219.312-.51.312-.872 0-.363-.104-.65-.312-.864a1.02 1.02 0 00-.784-.328c-.32 0-.584.11-.792.328-.203.213-.304.501-.304.864s.101.653.304.872c.208.213.472.32.792.32z" />
    </svg>
  );
}

export default Rupiah;
